/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApnEmployerDataScraperBody } from '../models';
// @ts-ignore
import type { ApnEmployerDataScraperV2Body } from '../models';
// @ts-ignore
import type { ApnaMissingJobsResponse } from '../models';
// @ts-ignore
import type { AssignModulesToQuestions } from '../models';
// @ts-ignore
import type { CourseGenerationJobDetail } from '../models';
// @ts-ignore
import type { CourseGenerationJobListResponse } from '../models';
// @ts-ignore
import type { CourseGenerationJobStarted } from '../models';
// @ts-ignore
import type { CreateJobDescriptionBody } from '../models';
// @ts-ignore
import type { CreateJobDescriptionResponse } from '../models';
// @ts-ignore
import type { EmployerDataScraperBody } from '../models';
// @ts-ignore
import type { EmployerSourcingRunListResponse } from '../models';
// @ts-ignore
import type { EmployerSourcingStatsResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GenerateModuleHierarchyBody } from '../models';
// @ts-ignore
import type { GetApplicantSkillsResponse } from '../models';
// @ts-ignore
import type { GetGeneratedJDResponse } from '../models';
// @ts-ignore
import type { GetGptResponseHistoryResponse } from '../models';
// @ts-ignore
import type { GetJobResumeAnalysis } from '../models';
// @ts-ignore
import type { GetNewGptResponse } from '../models';
// @ts-ignore
import type { GetNewGptResponseBody } from '../models';
// @ts-ignore
import type { IDListNumber } from '../models';
// @ts-ignore
import type { IdListLimit } from '../models';
// @ts-ignore
import type { ListJobResumeAnalysis } from '../models';
// @ts-ignore
import type { ListJobResumeAnalysisBody } from '../models';
// @ts-ignore
import type { Number } from '../models';
// @ts-ignore
import type { OptimEmployerDataScraperBody } from '../models';
// @ts-ignore
import type { OrgJobID } from '../models';
// @ts-ignore
import type { ProcessParsedQuestionsBody } from '../models';
// @ts-ignore
import type { QuestionDifficultyJobDetail } from '../models';
// @ts-ignore
import type { QuestionDifficultyJobStarted } from '../models';
// @ts-ignore
import type { RecruiterNormalisationBody } from '../models';
// @ts-ignore
import type { RefineByDomainModule } from '../models';
// @ts-ignore
import type { RefineCollegeBody } from '../models';
// @ts-ignore
import type { RefineCompanyBody } from '../models';
// @ts-ignore
import type { RefineJobRoleBody } from '../models';
// @ts-ignore
import type { RefineQuestionBody } from '../models';
// @ts-ignore
import type { ResumeAnalysisRetyResponse } from '../models';
// @ts-ignore
import type { ResumeEmployerSourcingRunBody } from '../models';
// @ts-ignore
import type { RetireExecuteBody } from '../models';
// @ts-ignore
import type { RetireExecuteResponse } from '../models';
// @ts-ignore
import type { RetirePreviewResponse } from '../models';
// @ts-ignore
import type { SkillBuilderEffectiveStrategyResponse } from '../models';
// @ts-ignore
import type { SkillBuilderEffectiveTemplateResponse } from '../models';
// @ts-ignore
import type { SkillBuilderPromptMappingResponse } from '../models';
// @ts-ignore
import type { SkillBuilderPromptMappingUpsertBody } from '../models';
// @ts-ignore
import type { SkillBuilderPromptTemplateCreateBody } from '../models';
// @ts-ignore
import type { SkillBuilderPromptTemplateListResponse } from '../models';
// @ts-ignore
import type { SkillBuilderPromptTemplateSingleResponse } from '../models';
// @ts-ignore
import type { SkillBuilderPromptTemplateUpdateBody } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyMappingResponse } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyMappingUpsertBody } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyTemplateCreateBody } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyTemplateListResponse } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyTemplateSingleResponse } from '../models';
// @ts-ignore
import type { SkillBuilderStrategyTemplateUpdateBody } from '../models';
// @ts-ignore
import type { SkillCoverageBody } from '../models';
// @ts-ignore
import type { SkillCoverageResponse } from '../models';
// @ts-ignore
import type { SkillRelevanceEstimateResponse } from '../models';
// @ts-ignore
import type { SkillRelevanceRunListResponse } from '../models';
// @ts-ignore
import type { SkillRelevanceRunResponse } from '../models';
// @ts-ignore
import type { SkillRelevanceScope } from '../models';
// @ts-ignore
import type { SourceQuestionsBody } from '../models';
// @ts-ignore
import type { StartCourseGenerationBody } from '../models';
// @ts-ignore
import type { StartEmployerSourcingRunResponse } from '../models';
// @ts-ignore
import type { StartQuestionDifficultyBody } from '../models';
// @ts-ignore
import type { SuccessMsg } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UploadApplicantResumeFileResponse } from '../models';
// @ts-ignore
import type { ValidateQuestionBody } from '../models';
// @ts-ignore
import type { ValidationRunListResponse } from '../models';
/**
 * GptApiApi - axios parameter creator
 */
export const GptApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {GenerateModuleHierarchyBody} generateModuleHierarchyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAiGenerateModuleHierarchy: async (generateModuleHierarchyBody: GenerateModuleHierarchyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateModuleHierarchyBody' is not null or undefined
            assertParamExists('gptApiAiGenerateModuleHierarchy', 'generateModuleHierarchyBody', generateModuleHierarchyBody)
            const localVarPath = `/admin/ai-generate-module-hierarchy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateModuleHierarchyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OrgJobID} orgJobID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAnalyzeJobQuality: async (orgJobID: OrgJobID, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgJobID' is not null or undefined
            assertParamExists('gptApiAnalyzeJobQuality', 'orgJobID', orgJobID)
            const localVarPath = `/gpt/analyze-job-quality/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orgJobID, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiApplicantResumeAnalysis: async (analysisId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('gptApiApplicantResumeAnalysis', 'analysisId', analysisId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiApplicantResumeAnalysis', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiApplicantResumeAnalysis', 'orgId', orgId)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/analysis/{analysis_id}/resume-pdf`
                .replace('{analysis_id}', encodeURIComponent(String(analysisId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignDomainsToQuestionsApi: async (iDListNumber: IDListNumber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDListNumber' is not null or undefined
            assertParamExists('gptApiAssignDomainsToQuestionsApi', 'iDListNumber', iDListNumber)
            const localVarPath = `/admin/assign-domains-to-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDListNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignDomainsToSkillsApi: async (number: Number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('gptApiAssignDomainsToSkillsApi', 'number', number)
            const localVarPath = `/admin/assign-domains-to-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(number, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AssignModulesToQuestions} assignModulesToQuestions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignModulesToQuestionsApi: async (assignModulesToQuestions: AssignModulesToQuestions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignModulesToQuestions' is not null or undefined
            assertParamExists('gptApiAssignModulesToQuestionsApi', 'assignModulesToQuestions', assignModulesToQuestions)
            const localVarPath = `/admin/assign-modules-to-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignModulesToQuestions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignModulesToSkillsApi: async (iDListNumber: IDListNumber, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iDListNumber' is not null or undefined
            assertParamExists('gptApiAssignModulesToSkillsApi', 'iDListNumber', iDListNumber)
            const localVarPath = `/admin/assign-modules-to-skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iDListNumber, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefineJobRoleBody} refineJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoRefineJobRole: async (refineJobRoleBody: RefineJobRoleBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineJobRoleBody' is not null or undefined
            assertParamExists('gptApiAutoRefineJobRole', 'refineJobRoleBody', refineJobRoleBody)
            const localVarPath = `/admin/refine-job-role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineJobRoleBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefineQuestionBody} refineQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoRefineQuestions: async (refineQuestionBody: RefineQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineQuestionBody' is not null or undefined
            assertParamExists('gptApiAutoRefineQuestions', 'refineQuestionBody', refineQuestionBody)
            const localVarPath = `/admin/refine-questions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefineCollegeBody} refineCollegeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoupdatePendingColleges: async (refineCollegeBody: RefineCollegeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineCollegeBody' is not null or undefined
            assertParamExists('gptApiAutoupdatePendingColleges', 'refineCollegeBody', refineCollegeBody)
            const localVarPath = `/admin/refine-colleges/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineCollegeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefineCompanyBody} refineCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoupdatePendingCompanies: async (refineCompanyBody: RefineCompanyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineCompanyBody' is not null or undefined
            assertParamExists('gptApiAutoupdatePendingCompanies', 'refineCompanyBody', refineCompanyBody)
            const localVarPath = `/admin/refine-companies/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineCompanyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {File} resumeFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiBulkAnalysisUploadResume: async (jobId: string, orgId: string, resumeFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiBulkAnalysisUploadResume', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiBulkAnalysisUploadResume', 'orgId', orgId)
            // verify required parameter 'resumeFile' is not null or undefined
            assertParamExists('gptApiBulkAnalysisUploadResume', 'resumeFile', resumeFile)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/upload-resume`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (resumeFile !== undefined) { 
                localVarFormParams.append('resume_file', resumeFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IdListLimit} idListLimit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiBulkAnalyzeResumeEntityJson: async (idListLimit: IdListLimit, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idListLimit' is not null or undefined
            assertParamExists('gptApiBulkAnalyzeResumeEntityJson', 'idListLimit', idListLimit)
            const localVarPath = `/admin/bulk-resume-entity-analysis/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(idListLimit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCancelCourseGenerationJob: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiCancelCourseGenerationJob', 'jobId', jobId)
            const localVarPath = `/admin/course/generation-job/{job_id}/cancel`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RetireExecuteBody} retireExecuteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCourseRetire: async (retireExecuteBody: RetireExecuteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retireExecuteBody' is not null or undefined
            assertParamExists('gptApiCourseRetire', 'retireExecuteBody', retireExecuteBody)
            const localVarPath = `/admin/course/retire`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retireExecuteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {string | null} [beforeTs] 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCourseRetirePreview: async (moduleId: string, beforeTs?: string | null, jobId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'moduleId' is not null or undefined
            assertParamExists('gptApiCourseRetirePreview', 'moduleId', moduleId)
            const localVarPath = `/admin/course/retire-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (beforeTs !== undefined) {
                localVarQueryParameter['before_ts'] = beforeTs;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (moduleId !== undefined) {
                localVarQueryParameter['module_id'] = moduleId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateJobDescriptionBody} createJobDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateJobDescription: async (orgId: string, createJobDescriptionBody: CreateJobDescriptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiCreateJobDescription', 'orgId', orgId)
            // verify required parameter 'createJobDescriptionBody' is not null or undefined
            assertParamExists('gptApiCreateJobDescription', 'createJobDescriptionBody', createJobDescriptionBody)
            const localVarPath = `/org/{org_id}/generated-jd`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobDescriptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderPromptTemplateCreateBody} skillBuilderPromptTemplateCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateSkillBuilderPromptTemplate: async (skillBuilderPromptTemplateCreateBody: SkillBuilderPromptTemplateCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderPromptTemplateCreateBody' is not null or undefined
            assertParamExists('gptApiCreateSkillBuilderPromptTemplate', 'skillBuilderPromptTemplateCreateBody', skillBuilderPromptTemplateCreateBody)
            const localVarPath = `/admin/skill-builder-prompt-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderPromptTemplateCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderStrategyTemplateCreateBody} skillBuilderStrategyTemplateCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateSkillBuilderStrategyTemplate: async (skillBuilderStrategyTemplateCreateBody: SkillBuilderStrategyTemplateCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderStrategyTemplateCreateBody' is not null or undefined
            assertParamExists('gptApiCreateSkillBuilderStrategyTemplate', 'skillBuilderStrategyTemplateCreateBody', skillBuilderStrategyTemplateCreateBody)
            const localVarPath = `/admin/skill-builder-strategy-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderStrategyTemplateCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gptResponseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteGptResponse: async (gptResponseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gptResponseId' is not null or undefined
            assertParamExists('gptApiDeleteGptResponse', 'gptResponseId', gptResponseId)
            const localVarPath = `/query/{gpt_response_id}`
                .replace('{gpt_response_id}', encodeURIComponent(String(gptResponseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderPromptMapping: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('gptApiDeleteSkillBuilderPromptMapping', 'skillId', skillId)
            const localVarPath = `/admin/skill-builder-prompt-mapping/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderPromptTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiDeleteSkillBuilderPromptTemplate', 'templateId', templateId)
            const localVarPath = `/admin/skill-builder-prompt-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderStrategyMapping: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('gptApiDeleteSkillBuilderStrategyMapping', 'skillId', skillId)
            const localVarPath = `/admin/skill-builder-strategy-mapping/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderStrategyTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiDeleteSkillBuilderStrategyTemplate', 'templateId', templateId)
            const localVarPath = `/admin/skill-builder-strategy-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ListJobResumeAnalysisBody} listJobResumeAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDownloadCsvApplicantResumeAnalysisPost: async (jobId: string, orgId: string, listJobResumeAnalysisBody: ListJobResumeAnalysisBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiDownloadCsvApplicantResumeAnalysisPost', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiDownloadCsvApplicantResumeAnalysisPost', 'orgId', orgId)
            // verify required parameter 'listJobResumeAnalysisBody' is not null or undefined
            assertParamExists('gptApiDownloadCsvApplicantResumeAnalysisPost', 'listJobResumeAnalysisBody', listJobResumeAnalysisBody)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/download-resume-csv`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listJobResumeAnalysisBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * body with two arrays, not something that belongs in a query string.
         * @summary Counts and cost for a scope, spending nothing. POST because the scope is a
         * @param {SkillRelevanceScope} skillRelevanceScope 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiEstimateSkillRelevanceScope: async (skillRelevanceScope: SkillRelevanceScope, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillRelevanceScope' is not null or undefined
            assertParamExists('gptApiEstimateSkillRelevanceScope', 'skillRelevanceScope', skillRelevanceScope)
            const localVarPath = `/admin/skill-relevance/estimate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillRelevanceScope, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefineByDomainModule} refineByDomainModule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGenerateSkillHierarchyDomainModule: async (refineByDomainModule: RefineByDomainModule, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refineByDomainModule' is not null or undefined
            assertParamExists('gptApiGenerateSkillHierarchyDomainModule', 'refineByDomainModule', refineByDomainModule)
            const localVarPath = `/admin/assign-topics-subtopics-to-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refineByDomainModule, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetAllValidationRuns: async (page?: string, pageSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/get-all-validation-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApnaMissingJobs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employer-sourcing/apna-missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApplicantResumeAnalysis: async (analysisId: string, jobId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('gptApiGetApplicantResumeAnalysis', 'analysisId', analysisId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiGetApplicantResumeAnalysis', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiGetApplicantResumeAnalysis', 'orgId', orgId)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/resume/{analysis_id}`
                .replace('{analysis_id}', encodeURIComponent(String(analysisId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApplicantSkills: async (jobId: string, orgId: string, searchQuery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiGetApplicantSkills', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiGetApplicantSkills', 'orgId', orgId)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/skills`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (searchQuery !== undefined) {
                localVarQueryParameter['search_query'] = searchQuery;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetCourseGenerationJobStatus: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiGetCourseGenerationJobStatus', 'jobId', jobId)
            const localVarPath = `/admin/course/generation-job/{job_id}/status`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jdId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetCreateJobDescription: async (jdId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jdId' is not null or undefined
            assertParamExists('gptApiGetCreateJobDescription', 'jdId', jdId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiGetCreateJobDescription', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/generated-jd/{jd_id}`
                .replace('{jd_id}', encodeURIComponent(String(jdId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {GptApiGetEmployerSourcingRunsSourceEnum} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetEmployerSourcingRuns: async (page?: number, pageSize?: number, source?: GptApiGetEmployerSourcingRunsSourceEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employer-sourcing/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetEmployerSourcingStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employer-sourcing/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetGptResponseHistory: async (endDate?: string, page?: number, pageSize?: number, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetNewGptResponseBody} getNewGptResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetNewGptResponse: async (getNewGptResponseBody: GetNewGptResponseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getNewGptResponseBody' is not null or undefined
            assertParamExists('gptApiGetNewGptResponse', 'getNewGptResponseBody', getNewGptResponseBody)
            const localVarPath = `/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getNewGptResponseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetQuestionDifficultyJobStatus: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiGetQuestionDifficultyJobStatus', 'jobId', jobId)
            const localVarPath = `/admin/question/difficulty/job/{job_id}/status`
                .replace('{job_id}', encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderEffectiveStrategy: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('gptApiGetSkillBuilderEffectiveStrategy', 'skillId', skillId)
            const localVarPath = `/admin/skill-builder-effective-strategy/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderEffectiveTemplate: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('gptApiGetSkillBuilderEffectiveTemplate', 'skillId', skillId)
            const localVarPath = `/admin/skill-builder-effective-template/{skill_id}`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderPromptTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiGetSkillBuilderPromptTemplate', 'templateId', templateId)
            const localVarPath = `/admin/skill-builder-prompt-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderStrategyTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiGetSkillBuilderStrategyTemplate', 'templateId', templateId)
            const localVarPath = `/admin/skill-builder-strategy-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ListJobResumeAnalysisBody} listJobResumeAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListApplicantResumeAnalysisPost: async (jobId: string, orgId: string, listJobResumeAnalysisBody: ListJobResumeAnalysisBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiListApplicantResumeAnalysisPost', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiListApplicantResumeAnalysisPost', 'orgId', orgId)
            // verify required parameter 'listJobResumeAnalysisBody' is not null or undefined
            assertParamExists('gptApiListApplicantResumeAnalysisPost', 'listJobResumeAnalysisBody', listJobResumeAnalysisBody)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/get-resume-list`
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listJobResumeAnalysisBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {string | null} [moduleId] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListCourseGenerationJobs: async (limit?: number, moduleId?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/course/generation-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (moduleId !== undefined) {
                localVarQueryParameter['module_id'] = moduleId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillBuilderPromptTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill-builder-prompt-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillBuilderStrategyTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill-builder-strategy-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillRelevanceRuns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill-relevance/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiNormaliseOptimEmployerData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/optim/normalise-employer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProcessParsedQuestionsBody} processParsedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiProcessParsedQuestions: async (processParsedQuestionsBody: ProcessParsedQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processParsedQuestionsBody' is not null or undefined
            assertParamExists('gptApiProcessParsedQuestions', 'processParsedQuestionsBody', processParsedQuestionsBody)
            const localVarPath = `/admin/process-parsed-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processParsedQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiProcessResumeEntitiesStudyStatus: async (number: Number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'number' is not null or undefined
            assertParamExists('gptApiProcessResumeEntitiesStudyStatus', 'number', number)
            const localVarPath = `/admin/process-resume-entities-study-status/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(number, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {ResumeEmployerSourcingRunBody} resumeEmployerSourcingRunBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiResumeEmployerSourcingRun: async (runId: string, resumeEmployerSourcingRunBody: ResumeEmployerSourcingRunBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('gptApiResumeEmployerSourcingRun', 'runId', runId)
            // verify required parameter 'resumeEmployerSourcingRunBody' is not null or undefined
            assertParamExists('gptApiResumeEmployerSourcingRun', 'resumeEmployerSourcingRunBody', resumeEmployerSourcingRunBody)
            const localVarPath = `/admin/employer-sourcing/runs/{run_id}/resume`
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resumeEmployerSourcingRunBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {boolean} [force] 
         * @param {string} [jobId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiRetryApplicantResumeAnalysis: async (analysisId: string, jobId: string, orgId: string, force?: boolean, jobId2?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisId' is not null or undefined
            assertParamExists('gptApiRetryApplicantResumeAnalysis', 'analysisId', analysisId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('gptApiRetryApplicantResumeAnalysis', 'jobId', jobId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('gptApiRetryApplicantResumeAnalysis', 'orgId', orgId)
            const localVarPath = `/bulk-resume-analysis/org/{org_id}/job/{job_id}/resume/{analysis_id}/retry`
                .replace('{analysis_id}', encodeURIComponent(String(analysisId)))
                .replace('{job_id}', encodeURIComponent(String(jobId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            if (jobId2 !== undefined) {
                localVarQueryParameter['job_id'] = jobId2;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * skill list is an array, not something that belongs in a query string.
         * @summary How many of each skill\'s questions already carry a weight. POST because the
         * @param {SkillCoverageBody} skillCoverageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSkillRelevanceCoverage: async (skillCoverageBody: SkillCoverageBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillCoverageBody' is not null or undefined
            assertParamExists('gptApiSkillRelevanceCoverage', 'skillCoverageBody', skillCoverageBody)
            const localVarPath = `/admin/skill-relevance/coverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillCoverageBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApnEmployerDataScraperBody} apnEmployerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceApnEmployerData: async (apnEmployerDataScraperBody: ApnEmployerDataScraperBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apnEmployerDataScraperBody' is not null or undefined
            assertParamExists('gptApiSourceApnEmployerData', 'apnEmployerDataScraperBody', apnEmployerDataScraperBody)
            const localVarPath = `/admin/apn/source-employer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apnEmployerDataScraperBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ApnEmployerDataScraperV2Body} apnEmployerDataScraperV2Body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceApnEmployerDataV2: async (apnEmployerDataScraperV2Body: ApnEmployerDataScraperV2Body, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apnEmployerDataScraperV2Body' is not null or undefined
            assertParamExists('gptApiSourceApnEmployerDataV2', 'apnEmployerDataScraperV2Body', apnEmployerDataScraperV2Body)
            const localVarPath = `/admin/apn/source-employer-data/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apnEmployerDataScraperV2Body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EmployerDataScraperBody} employerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceEmployerData: async (employerDataScraperBody: EmployerDataScraperBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employerDataScraperBody' is not null or undefined
            assertParamExists('gptApiSourceEmployerData', 'employerDataScraperBody', employerDataScraperBody)
            const localVarPath = `/admin/source-employer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(employerDataScraperBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OptimEmployerDataScraperBody} optimEmployerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceOptimEmployerData: async (optimEmployerDataScraperBody: OptimEmployerDataScraperBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'optimEmployerDataScraperBody' is not null or undefined
            assertParamExists('gptApiSourceOptimEmployerData', 'optimEmployerDataScraperBody', optimEmployerDataScraperBody)
            const localVarPath = `/admin/optim/source-employer-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(optimEmployerDataScraperBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SourceQuestionsBody} sourceQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceQuestions: async (sourceQuestionsBody: SourceQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceQuestionsBody' is not null or undefined
            assertParamExists('gptApiSourceQuestions', 'sourceQuestionsBody', sourceQuestionsBody)
            const localVarPath = `/admin/source-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sourceQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCourseGenerationBody} startCourseGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartCourseGeneration: async (startCourseGenerationBody: StartCourseGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startCourseGenerationBody' is not null or undefined
            assertParamExists('gptApiStartCourseGeneration', 'startCourseGenerationBody', startCourseGenerationBody)
            const localVarPath = `/admin/course/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCourseGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartCourseGenerationBody} startCourseGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartCourseGenerationPending: async (startCourseGenerationBody: StartCourseGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startCourseGenerationBody' is not null or undefined
            assertParamExists('gptApiStartCourseGenerationPending', 'startCourseGenerationBody', startCourseGenerationBody)
            const localVarPath = `/admin/course/generate-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCourseGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StartQuestionDifficultyBody} startQuestionDifficultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartQuestionDifficultyJob: async (startQuestionDifficultyBody: StartQuestionDifficultyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startQuestionDifficultyBody' is not null or undefined
            assertParamExists('gptApiStartQuestionDifficultyJob', 'startQuestionDifficultyBody', startQuestionDifficultyBody)
            const localVarPath = `/admin/question/difficulty/rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startQuestionDifficultyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RecruiterNormalisationBody} recruiterNormalisationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartRecruiterNormalisation: async (recruiterNormalisationBody: RecruiterNormalisationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recruiterNormalisationBody' is not null or undefined
            assertParamExists('gptApiStartRecruiterNormalisation', 'recruiterNormalisationBody', recruiterNormalisationBody)
            const localVarPath = `/admin/employer-sourcing/normalise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recruiterNormalisationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillRelevanceScope} skillRelevanceScope 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartSkillRelevanceRun: async (skillRelevanceScope: SkillRelevanceScope, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillRelevanceScope' is not null or undefined
            assertParamExists('gptApiStartSkillRelevanceRun', 'skillRelevanceScope', skillRelevanceScope)
            const localVarPath = `/admin/skill-relevance/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillRelevanceScope, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopEmployerSourcingRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('gptApiStopEmployerSourcingRun', 'runId', runId)
            const localVarPath = `/admin/employer-sourcing/runs/{run_id}/stop`
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopSkillRelevanceRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('gptApiStopSkillRelevanceRun', 'runId', runId)
            const localVarPath = `/admin/skill-relevance/runs/{run_id}/stop`
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopValidationRun: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('gptApiStopValidationRun', 'runId', runId)
            const localVarPath = `/admin/stop-validation-run/{run_id}`
                .replace('{run_id}', encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {SkillBuilderPromptTemplateUpdateBody} skillBuilderPromptTemplateUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpdateSkillBuilderPromptTemplate: async (templateId: string, skillBuilderPromptTemplateUpdateBody: SkillBuilderPromptTemplateUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiUpdateSkillBuilderPromptTemplate', 'templateId', templateId)
            // verify required parameter 'skillBuilderPromptTemplateUpdateBody' is not null or undefined
            assertParamExists('gptApiUpdateSkillBuilderPromptTemplate', 'skillBuilderPromptTemplateUpdateBody', skillBuilderPromptTemplateUpdateBody)
            const localVarPath = `/admin/skill-builder-prompt-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderPromptTemplateUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} templateId 
         * @param {SkillBuilderStrategyTemplateUpdateBody} skillBuilderStrategyTemplateUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpdateSkillBuilderStrategyTemplate: async (templateId: string, skillBuilderStrategyTemplateUpdateBody: SkillBuilderStrategyTemplateUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('gptApiUpdateSkillBuilderStrategyTemplate', 'templateId', templateId)
            // verify required parameter 'skillBuilderStrategyTemplateUpdateBody' is not null or undefined
            assertParamExists('gptApiUpdateSkillBuilderStrategyTemplate', 'skillBuilderStrategyTemplateUpdateBody', skillBuilderStrategyTemplateUpdateBody)
            const localVarPath = `/admin/skill-builder-strategy-template/{template_id}`
                .replace('{template_id}', encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderStrategyTemplateUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderPromptMappingUpsertBody} skillBuilderPromptMappingUpsertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpsertSkillBuilderPromptMapping: async (skillBuilderPromptMappingUpsertBody: SkillBuilderPromptMappingUpsertBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderPromptMappingUpsertBody' is not null or undefined
            assertParamExists('gptApiUpsertSkillBuilderPromptMapping', 'skillBuilderPromptMappingUpsertBody', skillBuilderPromptMappingUpsertBody)
            const localVarPath = `/admin/skill-builder-prompt-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderPromptMappingUpsertBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderStrategyMappingUpsertBody} skillBuilderStrategyMappingUpsertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpsertSkillBuilderStrategyMapping: async (skillBuilderStrategyMappingUpsertBody: SkillBuilderStrategyMappingUpsertBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderStrategyMappingUpsertBody' is not null or undefined
            assertParamExists('gptApiUpsertSkillBuilderStrategyMapping', 'skillBuilderStrategyMappingUpsertBody', skillBuilderStrategyMappingUpsertBody)
            const localVarPath = `/admin/skill-builder-strategy-mapping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderStrategyMappingUpsertBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateQuestionBody} validateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiValidateQuestions: async (validateQuestionBody: ValidateQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateQuestionBody' is not null or undefined
            assertParamExists('gptApiValidateQuestions', 'validateQuestionBody', validateQuestionBody)
            const localVarPath = `/admin/validate-questions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GptApiApi - functional programming interface
 */
export const GptApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GptApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {GenerateModuleHierarchyBody} generateModuleHierarchyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAiGenerateModuleHierarchy(generateModuleHierarchyBody: GenerateModuleHierarchyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAiGenerateModuleHierarchy(generateModuleHierarchyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAiGenerateModuleHierarchy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OrgJobID} orgJobID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAnalyzeJobQuality(orgJobID: OrgJobID, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAnalyzeJobQuality(orgJobID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAnalyzeJobQuality']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiApplicantResumeAnalysis(analysisId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiApplicantResumeAnalysis(analysisId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiApplicantResumeAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAssignDomainsToQuestionsApi(iDListNumber: IDListNumber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAssignDomainsToQuestionsApi(iDListNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAssignDomainsToQuestionsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAssignDomainsToSkillsApi(number: Number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAssignDomainsToSkillsApi(number, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAssignDomainsToSkillsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AssignModulesToQuestions} assignModulesToQuestions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAssignModulesToQuestionsApi(assignModulesToQuestions: AssignModulesToQuestions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAssignModulesToQuestionsApi(assignModulesToQuestions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAssignModulesToQuestionsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IDListNumber} iDListNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAssignModulesToSkillsApi(iDListNumber: IDListNumber, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAssignModulesToSkillsApi(iDListNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAssignModulesToSkillsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefineJobRoleBody} refineJobRoleBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAutoRefineJobRole(refineJobRoleBody: RefineJobRoleBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAutoRefineJobRole(refineJobRoleBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAutoRefineJobRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefineQuestionBody} refineQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAutoRefineQuestions(refineQuestionBody: RefineQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAutoRefineQuestions(refineQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAutoRefineQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefineCollegeBody} refineCollegeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAutoupdatePendingColleges(refineCollegeBody: RefineCollegeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAutoupdatePendingColleges(refineCollegeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAutoupdatePendingColleges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefineCompanyBody} refineCompanyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiAutoupdatePendingCompanies(refineCompanyBody: RefineCompanyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiAutoupdatePendingCompanies(refineCompanyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiAutoupdatePendingCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {File} resumeFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiBulkAnalysisUploadResume(jobId: string, orgId: string, resumeFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadApplicantResumeFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiBulkAnalysisUploadResume(jobId, orgId, resumeFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiBulkAnalysisUploadResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IdListLimit} idListLimit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiBulkAnalyzeResumeEntityJson(idListLimit: IdListLimit, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiBulkAnalyzeResumeEntityJson(idListLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiBulkAnalyzeResumeEntityJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCancelCourseGenerationJob(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseGenerationJobStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCancelCourseGenerationJob(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCancelCourseGenerationJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RetireExecuteBody} retireExecuteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCourseRetire(retireExecuteBody: RetireExecuteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetireExecuteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCourseRetire(retireExecuteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCourseRetire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} moduleId 
         * @param {string | null} [beforeTs] 
         * @param {string | null} [jobId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCourseRetirePreview(moduleId: string, beforeTs?: string | null, jobId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetirePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCourseRetirePreview(moduleId, beforeTs, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCourseRetirePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateJobDescriptionBody} createJobDescriptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCreateJobDescription(orgId: string, createJobDescriptionBody: CreateJobDescriptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobDescriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCreateJobDescription(orgId, createJobDescriptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCreateJobDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderPromptTemplateCreateBody} skillBuilderPromptTemplateCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCreateSkillBuilderPromptTemplate(skillBuilderPromptTemplateCreateBody: SkillBuilderPromptTemplateCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderPromptTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCreateSkillBuilderPromptTemplate(skillBuilderPromptTemplateCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCreateSkillBuilderPromptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderStrategyTemplateCreateBody} skillBuilderStrategyTemplateCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiCreateSkillBuilderStrategyTemplate(skillBuilderStrategyTemplateCreateBody: SkillBuilderStrategyTemplateCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderStrategyTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiCreateSkillBuilderStrategyTemplate(skillBuilderStrategyTemplateCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiCreateSkillBuilderStrategyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gptResponseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDeleteGptResponse(gptResponseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDeleteGptResponse(gptResponseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDeleteGptResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDeleteSkillBuilderPromptMapping(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDeleteSkillBuilderPromptMapping(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDeleteSkillBuilderPromptMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDeleteSkillBuilderPromptTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDeleteSkillBuilderPromptTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDeleteSkillBuilderPromptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDeleteSkillBuilderStrategyMapping(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDeleteSkillBuilderStrategyMapping(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDeleteSkillBuilderStrategyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDeleteSkillBuilderStrategyTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDeleteSkillBuilderStrategyTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDeleteSkillBuilderStrategyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ListJobResumeAnalysisBody} listJobResumeAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiDownloadCsvApplicantResumeAnalysisPost(jobId: string, orgId: string, listJobResumeAnalysisBody: ListJobResumeAnalysisBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiDownloadCsvApplicantResumeAnalysisPost(jobId, orgId, listJobResumeAnalysisBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiDownloadCsvApplicantResumeAnalysisPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * body with two arrays, not something that belongs in a query string.
         * @summary Counts and cost for a scope, spending nothing. POST because the scope is a
         * @param {SkillRelevanceScope} skillRelevanceScope 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiEstimateSkillRelevanceScope(skillRelevanceScope: SkillRelevanceScope, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillRelevanceEstimateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiEstimateSkillRelevanceScope(skillRelevanceScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiEstimateSkillRelevanceScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RefineByDomainModule} refineByDomainModule 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGenerateSkillHierarchyDomainModule(refineByDomainModule: RefineByDomainModule, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGenerateSkillHierarchyDomainModule(refineByDomainModule, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGenerateSkillHierarchyDomainModule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetAllValidationRuns(page?: string, pageSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationRunListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetAllValidationRuns(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetAllValidationRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetApnaMissingJobs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApnaMissingJobsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetApnaMissingJobs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetApnaMissingJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetApplicantResumeAnalysis(analysisId: string, jobId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetJobResumeAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetApplicantResumeAnalysis(analysisId, jobId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetApplicantResumeAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {string} [searchQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetApplicantSkills(jobId: string, orgId: string, searchQuery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicantSkillsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetApplicantSkills(jobId, orgId, searchQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetApplicantSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetCourseGenerationJobStatus(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseGenerationJobDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetCourseGenerationJobStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetCourseGenerationJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jdId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetCreateJobDescription(jdId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGeneratedJDResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetCreateJobDescription(jdId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetCreateJobDescription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {GptApiGetEmployerSourcingRunsSourceEnum} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetEmployerSourcingRuns(page?: number, pageSize?: number, source?: GptApiGetEmployerSourcingRunsSourceEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerSourcingRunListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetEmployerSourcingRuns(page, pageSize, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetEmployerSourcingRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetEmployerSourcingStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerSourcingStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetEmployerSourcingStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetEmployerSourcingStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetGptResponseHistory(endDate?: string, page?: number, pageSize?: number, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGptResponseHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetGptResponseHistory(endDate, page, pageSize, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetGptResponseHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GetNewGptResponseBody} getNewGptResponseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetNewGptResponse(getNewGptResponseBody: GetNewGptResponseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNewGptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetNewGptResponse(getNewGptResponseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetNewGptResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetQuestionDifficultyJobStatus(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDifficultyJobDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetQuestionDifficultyJobStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetQuestionDifficultyJobStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetSkillBuilderEffectiveStrategy(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderEffectiveStrategyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetSkillBuilderEffectiveStrategy(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetSkillBuilderEffectiveStrategy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetSkillBuilderEffectiveTemplate(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderEffectiveTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetSkillBuilderEffectiveTemplate(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetSkillBuilderEffectiveTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetSkillBuilderPromptTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderPromptTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetSkillBuilderPromptTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetSkillBuilderPromptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiGetSkillBuilderStrategyTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderStrategyTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiGetSkillBuilderStrategyTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiGetSkillBuilderStrategyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {ListJobResumeAnalysisBody} listJobResumeAnalysisBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiListApplicantResumeAnalysisPost(jobId: string, orgId: string, listJobResumeAnalysisBody: ListJobResumeAnalysisBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListJobResumeAnalysis>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiListApplicantResumeAnalysisPost(jobId, orgId, listJobResumeAnalysisBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiListApplicantResumeAnalysisPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {string | null} [moduleId] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiListCourseGenerationJobs(limit?: number, moduleId?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseGenerationJobListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiListCourseGenerationJobs(limit, moduleId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiListCourseGenerationJobs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiListSkillBuilderPromptTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderPromptTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiListSkillBuilderPromptTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiListSkillBuilderPromptTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiListSkillBuilderStrategyTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderStrategyTemplateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiListSkillBuilderStrategyTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiListSkillBuilderStrategyTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiListSkillRelevanceRuns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillRelevanceRunListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiListSkillRelevanceRuns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiListSkillRelevanceRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiNormaliseOptimEmployerData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiNormaliseOptimEmployerData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiNormaliseOptimEmployerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProcessParsedQuestionsBody} processParsedQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiProcessParsedQuestions(processParsedQuestionsBody: ProcessParsedQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiProcessParsedQuestions(processParsedQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiProcessParsedQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Number} number 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiProcessResumeEntitiesStudyStatus(number: Number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiProcessResumeEntitiesStudyStatus(number, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiProcessResumeEntitiesStudyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} runId 
         * @param {ResumeEmployerSourcingRunBody} resumeEmployerSourcingRunBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiResumeEmployerSourcingRun(runId: string, resumeEmployerSourcingRunBody: ResumeEmployerSourcingRunBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEmployerSourcingRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiResumeEmployerSourcingRun(runId, resumeEmployerSourcingRunBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiResumeEmployerSourcingRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisId 
         * @param {string} jobId 
         * @param {string} orgId 
         * @param {boolean} [force] 
         * @param {string} [jobId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiRetryApplicantResumeAnalysis(analysisId: string, jobId: string, orgId: string, force?: boolean, jobId2?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResumeAnalysisRetyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiRetryApplicantResumeAnalysis(analysisId, jobId, orgId, force, jobId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiRetryApplicantResumeAnalysis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * skill list is an array, not something that belongs in a query string.
         * @summary How many of each skill\'s questions already carry a weight. POST because the
         * @param {SkillCoverageBody} skillCoverageBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSkillRelevanceCoverage(skillCoverageBody: SkillCoverageBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillCoverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSkillRelevanceCoverage(skillCoverageBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSkillRelevanceCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ApnEmployerDataScraperBody} apnEmployerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSourceApnEmployerData(apnEmployerDataScraperBody: ApnEmployerDataScraperBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEmployerSourcingRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSourceApnEmployerData(apnEmployerDataScraperBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSourceApnEmployerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ApnEmployerDataScraperV2Body} apnEmployerDataScraperV2Body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSourceApnEmployerDataV2(apnEmployerDataScraperV2Body: ApnEmployerDataScraperV2Body, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEmployerSourcingRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSourceApnEmployerDataV2(apnEmployerDataScraperV2Body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSourceApnEmployerDataV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EmployerDataScraperBody} employerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSourceEmployerData(employerDataScraperBody: EmployerDataScraperBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEmployerSourcingRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSourceEmployerData(employerDataScraperBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSourceEmployerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OptimEmployerDataScraperBody} optimEmployerDataScraperBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSourceOptimEmployerData(optimEmployerDataScraperBody: OptimEmployerDataScraperBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSourceOptimEmployerData(optimEmployerDataScraperBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSourceOptimEmployerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SourceQuestionsBody} sourceQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiSourceQuestions(sourceQuestionsBody: SourceQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiSourceQuestions(sourceQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiSourceQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StartCourseGenerationBody} startCourseGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStartCourseGeneration(startCourseGenerationBody: StartCourseGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseGenerationJobStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStartCourseGeneration(startCourseGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStartCourseGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StartCourseGenerationBody} startCourseGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStartCourseGenerationPending(startCourseGenerationBody: StartCourseGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CourseGenerationJobStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStartCourseGenerationPending(startCourseGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStartCourseGenerationPending']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StartQuestionDifficultyBody} startQuestionDifficultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStartQuestionDifficultyJob(startQuestionDifficultyBody: StartQuestionDifficultyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDifficultyJobStarted>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStartQuestionDifficultyJob(startQuestionDifficultyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStartQuestionDifficultyJob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RecruiterNormalisationBody} recruiterNormalisationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStartRecruiterNormalisation(recruiterNormalisationBody: RecruiterNormalisationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartEmployerSourcingRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStartRecruiterNormalisation(recruiterNormalisationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStartRecruiterNormalisation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillRelevanceScope} skillRelevanceScope 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStartSkillRelevanceRun(skillRelevanceScope: SkillRelevanceScope, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillRelevanceRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStartSkillRelevanceRun(skillRelevanceScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStartSkillRelevanceRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStopEmployerSourcingRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStopEmployerSourcingRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStopEmployerSourcingRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStopSkillRelevanceRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillRelevanceRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStopSkillRelevanceRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStopSkillRelevanceRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiStopValidationRun(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiStopValidationRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiStopValidationRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {SkillBuilderPromptTemplateUpdateBody} skillBuilderPromptTemplateUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiUpdateSkillBuilderPromptTemplate(templateId: string, skillBuilderPromptTemplateUpdateBody: SkillBuilderPromptTemplateUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderPromptTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiUpdateSkillBuilderPromptTemplate(templateId, skillBuilderPromptTemplateUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiUpdateSkillBuilderPromptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} templateId 
         * @param {SkillBuilderStrategyTemplateUpdateBody} skillBuilderStrategyTemplateUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiUpdateSkillBuilderStrategyTemplate(templateId: string, skillBuilderStrategyTemplateUpdateBody: SkillBuilderStrategyTemplateUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderStrategyTemplateSingleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiUpdateSkillBuilderStrategyTemplate(templateId, skillBuilderStrategyTemplateUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiUpdateSkillBuilderStrategyTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderPromptMappingUpsertBody} skillBuilderPromptMappingUpsertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiUpsertSkillBuilderPromptMapping(skillBuilderPromptMappingUpsertBody: SkillBuilderPromptMappingUpsertBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderPromptMappingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiUpsertSkillBuilderPromptMapping(skillBuilderPromptMappingUpsertBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiUpsertSkillBuilderPromptMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderStrategyMappingUpsertBody} skillBuilderStrategyMappingUpsertBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiUpsertSkillBuilderStrategyMapping(skillBuilderStrategyMappingUpsertBody: SkillBuilderStrategyMappingUpsertBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderStrategyMappingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiUpsertSkillBuilderStrategyMapping(skillBuilderStrategyMappingUpsertBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiUpsertSkillBuilderStrategyMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateQuestionBody} validateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gptApiValidateQuestions(validateQuestionBody: ValidateQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gptApiValidateQuestions(validateQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GptApiApi.gptApiValidateQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GptApiApi - factory interface
 */
export const GptApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GptApiApiFp(configuration)
    return {
        /**
         * 
         * @param {GptApiApiGptApiAiGenerateModuleHierarchyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAiGenerateModuleHierarchy(requestParameters: GptApiApiGptApiAiGenerateModuleHierarchyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAiGenerateModuleHierarchy(requestParameters.generateModuleHierarchyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAnalyzeJobQualityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAnalyzeJobQuality(requestParameters: GptApiApiGptApiAnalyzeJobQualityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAnalyzeJobQuality(requestParameters.orgJobID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiApplicantResumeAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiApplicantResumeAnalysis(requestParameters: GptApiApiGptApiApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.gptApiApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAssignDomainsToQuestionsApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignDomainsToQuestionsApi(requestParameters: GptApiApiGptApiAssignDomainsToQuestionsApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAssignDomainsToQuestionsApi(requestParameters.iDListNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAssignDomainsToSkillsApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignDomainsToSkillsApi(requestParameters: GptApiApiGptApiAssignDomainsToSkillsApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAssignDomainsToSkillsApi(requestParameters.number, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAssignModulesToQuestionsApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignModulesToQuestionsApi(requestParameters: GptApiApiGptApiAssignModulesToQuestionsApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAssignModulesToQuestionsApi(requestParameters.assignModulesToQuestions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAssignModulesToSkillsApiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAssignModulesToSkillsApi(requestParameters: GptApiApiGptApiAssignModulesToSkillsApiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAssignModulesToSkillsApi(requestParameters.iDListNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAutoRefineJobRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoRefineJobRole(requestParameters: GptApiApiGptApiAutoRefineJobRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAutoRefineJobRole(requestParameters.refineJobRoleBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAutoRefineQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoRefineQuestions(requestParameters: GptApiApiGptApiAutoRefineQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAutoRefineQuestions(requestParameters.refineQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAutoupdatePendingCollegesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoupdatePendingColleges(requestParameters: GptApiApiGptApiAutoupdatePendingCollegesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAutoupdatePendingColleges(requestParameters.refineCollegeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiAutoupdatePendingCompaniesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiAutoupdatePendingCompanies(requestParameters: GptApiApiGptApiAutoupdatePendingCompaniesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiAutoupdatePendingCompanies(requestParameters.refineCompanyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiBulkAnalysisUploadResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiBulkAnalysisUploadResume(requestParameters: GptApiApiGptApiBulkAnalysisUploadResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadApplicantResumeFileResponse> {
            return localVarFp.gptApiBulkAnalysisUploadResume(requestParameters.jobId, requestParameters.orgId, requestParameters.resumeFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiBulkAnalyzeResumeEntityJsonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiBulkAnalyzeResumeEntityJson(requestParameters: GptApiApiGptApiBulkAnalyzeResumeEntityJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.gptApiBulkAnalyzeResumeEntityJson(requestParameters.idListLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCancelCourseGenerationJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCancelCourseGenerationJob(requestParameters: GptApiApiGptApiCancelCourseGenerationJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseGenerationJobStarted> {
            return localVarFp.gptApiCancelCourseGenerationJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCourseRetireRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCourseRetire(requestParameters: GptApiApiGptApiCourseRetireRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetireExecuteResponse> {
            return localVarFp.gptApiCourseRetire(requestParameters.retireExecuteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCourseRetirePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCourseRetirePreview(requestParameters: GptApiApiGptApiCourseRetirePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<RetirePreviewResponse> {
            return localVarFp.gptApiCourseRetirePreview(requestParameters.moduleId, requestParameters.beforeTs, requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCreateJobDescriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateJobDescription(requestParameters: GptApiApiGptApiCreateJobDescriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobDescriptionResponse> {
            return localVarFp.gptApiCreateJobDescription(requestParameters.orgId, requestParameters.createJobDescriptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCreateSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiCreateSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderPromptTemplateSingleResponse> {
            return localVarFp.gptApiCreateSkillBuilderPromptTemplate(requestParameters.skillBuilderPromptTemplateCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiCreateSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiCreateSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiCreateSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderStrategyTemplateSingleResponse> {
            return localVarFp.gptApiCreateSkillBuilderStrategyTemplate(requestParameters.skillBuilderStrategyTemplateCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDeleteGptResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteGptResponse(requestParameters: GptApiApiGptApiDeleteGptResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiDeleteGptResponse(requestParameters.gptResponseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDeleteSkillBuilderPromptMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderPromptMapping(requestParameters: GptApiApiGptApiDeleteSkillBuilderPromptMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiDeleteSkillBuilderPromptMapping(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDeleteSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiDeleteSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiDeleteSkillBuilderPromptTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDeleteSkillBuilderStrategyMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderStrategyMapping(requestParameters: GptApiApiGptApiDeleteSkillBuilderStrategyMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiDeleteSkillBuilderStrategyMapping(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDeleteSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDeleteSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiDeleteSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiDeleteSkillBuilderStrategyTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiDownloadCsvApplicantResumeAnalysisPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiDownloadCsvApplicantResumeAnalysisPost(requestParameters: GptApiApiGptApiDownloadCsvApplicantResumeAnalysisPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.gptApiDownloadCsvApplicantResumeAnalysisPost(requestParameters.jobId, requestParameters.orgId, requestParameters.listJobResumeAnalysisBody, options).then((request) => request(axios, basePath));
        },
        /**
         * body with two arrays, not something that belongs in a query string.
         * @summary Counts and cost for a scope, spending nothing. POST because the scope is a
         * @param {GptApiApiGptApiEstimateSkillRelevanceScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiEstimateSkillRelevanceScope(requestParameters: GptApiApiGptApiEstimateSkillRelevanceScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillRelevanceEstimateResponse> {
            return localVarFp.gptApiEstimateSkillRelevanceScope(requestParameters.skillRelevanceScope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGenerateSkillHierarchyDomainModuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGenerateSkillHierarchyDomainModule(requestParameters: GptApiApiGptApiGenerateSkillHierarchyDomainModuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiGenerateSkillHierarchyDomainModule(requestParameters.refineByDomainModule, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetAllValidationRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetAllValidationRuns(requestParameters: GptApiApiGptApiGetAllValidationRunsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ValidationRunListResponse> {
            return localVarFp.gptApiGetAllValidationRuns(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApnaMissingJobs(options?: RawAxiosRequestConfig): AxiosPromise<ApnaMissingJobsResponse> {
            return localVarFp.gptApiGetApnaMissingJobs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetApplicantResumeAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApplicantResumeAnalysis(requestParameters: GptApiApiGptApiGetApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetJobResumeAnalysis> {
            return localVarFp.gptApiGetApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetApplicantSkillsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetApplicantSkills(requestParameters: GptApiApiGptApiGetApplicantSkillsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetApplicantSkillsResponse> {
            return localVarFp.gptApiGetApplicantSkills(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetCourseGenerationJobStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetCourseGenerationJobStatus(requestParameters: GptApiApiGptApiGetCourseGenerationJobStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseGenerationJobDetail> {
            return localVarFp.gptApiGetCourseGenerationJobStatus(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetCreateJobDescriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetCreateJobDescription(requestParameters: GptApiApiGptApiGetCreateJobDescriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetGeneratedJDResponse> {
            return localVarFp.gptApiGetCreateJobDescription(requestParameters.jdId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetEmployerSourcingRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetEmployerSourcingRuns(requestParameters: GptApiApiGptApiGetEmployerSourcingRunsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmployerSourcingRunListResponse> {
            return localVarFp.gptApiGetEmployerSourcingRuns(requestParameters.page, requestParameters.pageSize, requestParameters.source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetEmployerSourcingStats(options?: RawAxiosRequestConfig): AxiosPromise<EmployerSourcingStatsResponse> {
            return localVarFp.gptApiGetEmployerSourcingStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetGptResponseHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetGptResponseHistory(requestParameters: GptApiApiGptApiGetGptResponseHistoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetGptResponseHistoryResponse> {
            return localVarFp.gptApiGetGptResponseHistory(requestParameters.endDate, requestParameters.page, requestParameters.pageSize, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetNewGptResponseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetNewGptResponse(requestParameters: GptApiApiGptApiGetNewGptResponseRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetNewGptResponse> {
            return localVarFp.gptApiGetNewGptResponse(requestParameters.getNewGptResponseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetQuestionDifficultyJobStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetQuestionDifficultyJobStatus(requestParameters: GptApiApiGptApiGetQuestionDifficultyJobStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDifficultyJobDetail> {
            return localVarFp.gptApiGetQuestionDifficultyJobStatus(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetSkillBuilderEffectiveStrategyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderEffectiveStrategy(requestParameters: GptApiApiGptApiGetSkillBuilderEffectiveStrategyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderEffectiveStrategyResponse> {
            return localVarFp.gptApiGetSkillBuilderEffectiveStrategy(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetSkillBuilderEffectiveTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderEffectiveTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderEffectiveTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderEffectiveTemplateResponse> {
            return localVarFp.gptApiGetSkillBuilderEffectiveTemplate(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderPromptTemplateSingleResponse> {
            return localVarFp.gptApiGetSkillBuilderPromptTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiGetSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiGetSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderStrategyTemplateSingleResponse> {
            return localVarFp.gptApiGetSkillBuilderStrategyTemplate(requestParameters.templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiListApplicantResumeAnalysisPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListApplicantResumeAnalysisPost(requestParameters: GptApiApiGptApiListApplicantResumeAnalysisPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListJobResumeAnalysis> {
            return localVarFp.gptApiListApplicantResumeAnalysisPost(requestParameters.jobId, requestParameters.orgId, requestParameters.listJobResumeAnalysisBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiListCourseGenerationJobsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListCourseGenerationJobs(requestParameters: GptApiApiGptApiListCourseGenerationJobsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CourseGenerationJobListResponse> {
            return localVarFp.gptApiListCourseGenerationJobs(requestParameters.limit, requestParameters.moduleId, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillBuilderPromptTemplates(options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderPromptTemplateListResponse> {
            return localVarFp.gptApiListSkillBuilderPromptTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillBuilderStrategyTemplates(options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderStrategyTemplateListResponse> {
            return localVarFp.gptApiListSkillBuilderStrategyTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiListSkillRelevanceRuns(options?: RawAxiosRequestConfig): AxiosPromise<SkillRelevanceRunListResponse> {
            return localVarFp.gptApiListSkillRelevanceRuns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiNormaliseOptimEmployerData(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiNormaliseOptimEmployerData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiProcessParsedQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiProcessParsedQuestions(requestParameters: GptApiApiGptApiProcessParsedQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiProcessParsedQuestions(requestParameters.processParsedQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiProcessResumeEntitiesStudyStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiProcessResumeEntitiesStudyStatus(requestParameters: GptApiApiGptApiProcessResumeEntitiesStudyStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiProcessResumeEntitiesStudyStatus(requestParameters.number, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiResumeEmployerSourcingRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiResumeEmployerSourcingRun(requestParameters: GptApiApiGptApiResumeEmployerSourcingRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartEmployerSourcingRunResponse> {
            return localVarFp.gptApiResumeEmployerSourcingRun(requestParameters.runId, requestParameters.resumeEmployerSourcingRunBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiRetryApplicantResumeAnalysisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiRetryApplicantResumeAnalysis(requestParameters: GptApiApiGptApiRetryApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResumeAnalysisRetyResponse> {
            return localVarFp.gptApiRetryApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, requestParameters.force, requestParameters.jobId2, options).then((request) => request(axios, basePath));
        },
        /**
         * skill list is an array, not something that belongs in a query string.
         * @summary How many of each skill\'s questions already carry a weight. POST because the
         * @param {GptApiApiGptApiSkillRelevanceCoverageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSkillRelevanceCoverage(requestParameters: GptApiApiGptApiSkillRelevanceCoverageRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillCoverageResponse> {
            return localVarFp.gptApiSkillRelevanceCoverage(requestParameters.skillCoverageBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiSourceApnEmployerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceApnEmployerData(requestParameters: GptApiApiGptApiSourceApnEmployerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartEmployerSourcingRunResponse> {
            return localVarFp.gptApiSourceApnEmployerData(requestParameters.apnEmployerDataScraperBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiSourceApnEmployerDataV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceApnEmployerDataV2(requestParameters: GptApiApiGptApiSourceApnEmployerDataV2Request, options?: RawAxiosRequestConfig): AxiosPromise<StartEmployerSourcingRunResponse> {
            return localVarFp.gptApiSourceApnEmployerDataV2(requestParameters.apnEmployerDataScraperV2Body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiSourceEmployerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceEmployerData(requestParameters: GptApiApiGptApiSourceEmployerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartEmployerSourcingRunResponse> {
            return localVarFp.gptApiSourceEmployerData(requestParameters.employerDataScraperBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiSourceOptimEmployerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceOptimEmployerData(requestParameters: GptApiApiGptApiSourceOptimEmployerDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiSourceOptimEmployerData(requestParameters.optimEmployerDataScraperBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiSourceQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiSourceQuestions(requestParameters: GptApiApiGptApiSourceQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiSourceQuestions(requestParameters.sourceQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStartCourseGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartCourseGeneration(requestParameters: GptApiApiGptApiStartCourseGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseGenerationJobStarted> {
            return localVarFp.gptApiStartCourseGeneration(requestParameters.startCourseGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStartCourseGenerationPendingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartCourseGenerationPending(requestParameters: GptApiApiGptApiStartCourseGenerationPendingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CourseGenerationJobStarted> {
            return localVarFp.gptApiStartCourseGenerationPending(requestParameters.startCourseGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStartQuestionDifficultyJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartQuestionDifficultyJob(requestParameters: GptApiApiGptApiStartQuestionDifficultyJobRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDifficultyJobStarted> {
            return localVarFp.gptApiStartQuestionDifficultyJob(requestParameters.startQuestionDifficultyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStartRecruiterNormalisationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartRecruiterNormalisation(requestParameters: GptApiApiGptApiStartRecruiterNormalisationRequest, options?: RawAxiosRequestConfig): AxiosPromise<StartEmployerSourcingRunResponse> {
            return localVarFp.gptApiStartRecruiterNormalisation(requestParameters.recruiterNormalisationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStartSkillRelevanceRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStartSkillRelevanceRun(requestParameters: GptApiApiGptApiStartSkillRelevanceRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillRelevanceRunResponse> {
            return localVarFp.gptApiStartSkillRelevanceRun(requestParameters.skillRelevanceScope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStopEmployerSourcingRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopEmployerSourcingRun(requestParameters: GptApiApiGptApiStopEmployerSourcingRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiStopEmployerSourcingRun(requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStopSkillRelevanceRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopSkillRelevanceRun(requestParameters: GptApiApiGptApiStopSkillRelevanceRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillRelevanceRunResponse> {
            return localVarFp.gptApiStopSkillRelevanceRun(requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiStopValidationRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiStopValidationRun(requestParameters: GptApiApiGptApiStopValidationRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiStopValidationRun(requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiUpdateSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpdateSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiUpdateSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderPromptTemplateSingleResponse> {
            return localVarFp.gptApiUpdateSkillBuilderPromptTemplate(requestParameters.templateId, requestParameters.skillBuilderPromptTemplateUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiUpdateSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpdateSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiUpdateSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderStrategyTemplateSingleResponse> {
            return localVarFp.gptApiUpdateSkillBuilderStrategyTemplate(requestParameters.templateId, requestParameters.skillBuilderStrategyTemplateUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiUpsertSkillBuilderPromptMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpsertSkillBuilderPromptMapping(requestParameters: GptApiApiGptApiUpsertSkillBuilderPromptMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderPromptMappingResponse> {
            return localVarFp.gptApiUpsertSkillBuilderPromptMapping(requestParameters.skillBuilderPromptMappingUpsertBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiUpsertSkillBuilderStrategyMappingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiUpsertSkillBuilderStrategyMapping(requestParameters: GptApiApiGptApiUpsertSkillBuilderStrategyMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderStrategyMappingResponse> {
            return localVarFp.gptApiUpsertSkillBuilderStrategyMapping(requestParameters.skillBuilderStrategyMappingUpsertBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GptApiApiGptApiValidateQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gptApiValidateQuestions(requestParameters: GptApiApiGptApiValidateQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.gptApiValidateQuestions(requestParameters.validateQuestionBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for gptApiAiGenerateModuleHierarchy operation in GptApiApi.
 */
export interface GptApiApiGptApiAiGenerateModuleHierarchyRequest {
    readonly generateModuleHierarchyBody: GenerateModuleHierarchyBody
}

/**
 * Request parameters for gptApiAnalyzeJobQuality operation in GptApiApi.
 */
export interface GptApiApiGptApiAnalyzeJobQualityRequest {
    readonly orgJobID: OrgJobID
}

/**
 * Request parameters for gptApiApplicantResumeAnalysis operation in GptApiApi.
 */
export interface GptApiApiGptApiApplicantResumeAnalysisRequest {
    readonly analysisId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for gptApiAssignDomainsToQuestionsApi operation in GptApiApi.
 */
export interface GptApiApiGptApiAssignDomainsToQuestionsApiRequest {
    readonly iDListNumber: IDListNumber
}

/**
 * Request parameters for gptApiAssignDomainsToSkillsApi operation in GptApiApi.
 */
export interface GptApiApiGptApiAssignDomainsToSkillsApiRequest {
    readonly number: Number
}

/**
 * Request parameters for gptApiAssignModulesToQuestionsApi operation in GptApiApi.
 */
export interface GptApiApiGptApiAssignModulesToQuestionsApiRequest {
    readonly assignModulesToQuestions: AssignModulesToQuestions
}

/**
 * Request parameters for gptApiAssignModulesToSkillsApi operation in GptApiApi.
 */
export interface GptApiApiGptApiAssignModulesToSkillsApiRequest {
    readonly iDListNumber: IDListNumber
}

/**
 * Request parameters for gptApiAutoRefineJobRole operation in GptApiApi.
 */
export interface GptApiApiGptApiAutoRefineJobRoleRequest {
    readonly refineJobRoleBody: RefineJobRoleBody
}

/**
 * Request parameters for gptApiAutoRefineQuestions operation in GptApiApi.
 */
export interface GptApiApiGptApiAutoRefineQuestionsRequest {
    readonly refineQuestionBody: RefineQuestionBody
}

/**
 * Request parameters for gptApiAutoupdatePendingColleges operation in GptApiApi.
 */
export interface GptApiApiGptApiAutoupdatePendingCollegesRequest {
    readonly refineCollegeBody: RefineCollegeBody
}

/**
 * Request parameters for gptApiAutoupdatePendingCompanies operation in GptApiApi.
 */
export interface GptApiApiGptApiAutoupdatePendingCompaniesRequest {
    readonly refineCompanyBody: RefineCompanyBody
}

/**
 * Request parameters for gptApiBulkAnalysisUploadResume operation in GptApiApi.
 */
export interface GptApiApiGptApiBulkAnalysisUploadResumeRequest {
    readonly jobId: string

    readonly orgId: string

    readonly resumeFile: File
}

/**
 * Request parameters for gptApiBulkAnalyzeResumeEntityJson operation in GptApiApi.
 */
export interface GptApiApiGptApiBulkAnalyzeResumeEntityJsonRequest {
    readonly idListLimit: IdListLimit
}

/**
 * Request parameters for gptApiCancelCourseGenerationJob operation in GptApiApi.
 */
export interface GptApiApiGptApiCancelCourseGenerationJobRequest {
    readonly jobId: string
}

/**
 * Request parameters for gptApiCourseRetire operation in GptApiApi.
 */
export interface GptApiApiGptApiCourseRetireRequest {
    readonly retireExecuteBody: RetireExecuteBody
}

/**
 * Request parameters for gptApiCourseRetirePreview operation in GptApiApi.
 */
export interface GptApiApiGptApiCourseRetirePreviewRequest {
    readonly moduleId: string

    readonly beforeTs?: string | null

    readonly jobId?: string | null
}

/**
 * Request parameters for gptApiCreateJobDescription operation in GptApiApi.
 */
export interface GptApiApiGptApiCreateJobDescriptionRequest {
    readonly orgId: string

    readonly createJobDescriptionBody: CreateJobDescriptionBody
}

/**
 * Request parameters for gptApiCreateSkillBuilderPromptTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiCreateSkillBuilderPromptTemplateRequest {
    readonly skillBuilderPromptTemplateCreateBody: SkillBuilderPromptTemplateCreateBody
}

/**
 * Request parameters for gptApiCreateSkillBuilderStrategyTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiCreateSkillBuilderStrategyTemplateRequest {
    readonly skillBuilderStrategyTemplateCreateBody: SkillBuilderStrategyTemplateCreateBody
}

/**
 * Request parameters for gptApiDeleteGptResponse operation in GptApiApi.
 */
export interface GptApiApiGptApiDeleteGptResponseRequest {
    readonly gptResponseId: string
}

/**
 * Request parameters for gptApiDeleteSkillBuilderPromptMapping operation in GptApiApi.
 */
export interface GptApiApiGptApiDeleteSkillBuilderPromptMappingRequest {
    readonly skillId: string
}

/**
 * Request parameters for gptApiDeleteSkillBuilderPromptTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiDeleteSkillBuilderPromptTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for gptApiDeleteSkillBuilderStrategyMapping operation in GptApiApi.
 */
export interface GptApiApiGptApiDeleteSkillBuilderStrategyMappingRequest {
    readonly skillId: string
}

/**
 * Request parameters for gptApiDeleteSkillBuilderStrategyTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiDeleteSkillBuilderStrategyTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for gptApiDownloadCsvApplicantResumeAnalysisPost operation in GptApiApi.
 */
export interface GptApiApiGptApiDownloadCsvApplicantResumeAnalysisPostRequest {
    readonly jobId: string

    readonly orgId: string

    readonly listJobResumeAnalysisBody: ListJobResumeAnalysisBody
}

/**
 * Request parameters for gptApiEstimateSkillRelevanceScope operation in GptApiApi.
 */
export interface GptApiApiGptApiEstimateSkillRelevanceScopeRequest {
    readonly skillRelevanceScope: SkillRelevanceScope
}

/**
 * Request parameters for gptApiGenerateSkillHierarchyDomainModule operation in GptApiApi.
 */
export interface GptApiApiGptApiGenerateSkillHierarchyDomainModuleRequest {
    readonly refineByDomainModule: RefineByDomainModule
}

/**
 * Request parameters for gptApiGetAllValidationRuns operation in GptApiApi.
 */
export interface GptApiApiGptApiGetAllValidationRunsRequest {
    readonly page?: string

    readonly pageSize?: string
}

/**
 * Request parameters for gptApiGetApplicantResumeAnalysis operation in GptApiApi.
 */
export interface GptApiApiGptApiGetApplicantResumeAnalysisRequest {
    readonly analysisId: string

    readonly jobId: string

    readonly orgId: string
}

/**
 * Request parameters for gptApiGetApplicantSkills operation in GptApiApi.
 */
export interface GptApiApiGptApiGetApplicantSkillsRequest {
    readonly jobId: string

    readonly orgId: string

    readonly searchQuery?: string
}

/**
 * Request parameters for gptApiGetCourseGenerationJobStatus operation in GptApiApi.
 */
export interface GptApiApiGptApiGetCourseGenerationJobStatusRequest {
    readonly jobId: string
}

/**
 * Request parameters for gptApiGetCreateJobDescription operation in GptApiApi.
 */
export interface GptApiApiGptApiGetCreateJobDescriptionRequest {
    readonly jdId: string

    readonly orgId: string
}

/**
 * Request parameters for gptApiGetEmployerSourcingRuns operation in GptApiApi.
 */
export interface GptApiApiGptApiGetEmployerSourcingRunsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly source?: GptApiGetEmployerSourcingRunsSourceEnum
}

/**
 * Request parameters for gptApiGetGptResponseHistory operation in GptApiApi.
 */
export interface GptApiApiGptApiGetGptResponseHistoryRequest {
    readonly endDate?: string

    readonly page?: number

    readonly pageSize?: number

    readonly startDate?: string
}

/**
 * Request parameters for gptApiGetNewGptResponse operation in GptApiApi.
 */
export interface GptApiApiGptApiGetNewGptResponseRequest {
    readonly getNewGptResponseBody: GetNewGptResponseBody
}

/**
 * Request parameters for gptApiGetQuestionDifficultyJobStatus operation in GptApiApi.
 */
export interface GptApiApiGptApiGetQuestionDifficultyJobStatusRequest {
    readonly jobId: string
}

/**
 * Request parameters for gptApiGetSkillBuilderEffectiveStrategy operation in GptApiApi.
 */
export interface GptApiApiGptApiGetSkillBuilderEffectiveStrategyRequest {
    readonly skillId: string
}

/**
 * Request parameters for gptApiGetSkillBuilderEffectiveTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiGetSkillBuilderEffectiveTemplateRequest {
    readonly skillId: string
}

/**
 * Request parameters for gptApiGetSkillBuilderPromptTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiGetSkillBuilderPromptTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for gptApiGetSkillBuilderStrategyTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiGetSkillBuilderStrategyTemplateRequest {
    readonly templateId: string
}

/**
 * Request parameters for gptApiListApplicantResumeAnalysisPost operation in GptApiApi.
 */
export interface GptApiApiGptApiListApplicantResumeAnalysisPostRequest {
    readonly jobId: string

    readonly orgId: string

    readonly listJobResumeAnalysisBody: ListJobResumeAnalysisBody
}

/**
 * Request parameters for gptApiListCourseGenerationJobs operation in GptApiApi.
 */
export interface GptApiApiGptApiListCourseGenerationJobsRequest {
    readonly limit?: number

    readonly moduleId?: string | null

    readonly status?: string | null
}

/**
 * Request parameters for gptApiProcessParsedQuestions operation in GptApiApi.
 */
export interface GptApiApiGptApiProcessParsedQuestionsRequest {
    readonly processParsedQuestionsBody: ProcessParsedQuestionsBody
}

/**
 * Request parameters for gptApiProcessResumeEntitiesStudyStatus operation in GptApiApi.
 */
export interface GptApiApiGptApiProcessResumeEntitiesStudyStatusRequest {
    readonly number: Number
}

/**
 * Request parameters for gptApiResumeEmployerSourcingRun operation in GptApiApi.
 */
export interface GptApiApiGptApiResumeEmployerSourcingRunRequest {
    readonly runId: string

    readonly resumeEmployerSourcingRunBody: ResumeEmployerSourcingRunBody
}

/**
 * Request parameters for gptApiRetryApplicantResumeAnalysis operation in GptApiApi.
 */
export interface GptApiApiGptApiRetryApplicantResumeAnalysisRequest {
    readonly analysisId: string

    readonly jobId: string

    readonly orgId: string

    readonly force?: boolean

    readonly jobId2?: string
}

/**
 * Request parameters for gptApiSkillRelevanceCoverage operation in GptApiApi.
 */
export interface GptApiApiGptApiSkillRelevanceCoverageRequest {
    readonly skillCoverageBody: SkillCoverageBody
}

/**
 * Request parameters for gptApiSourceApnEmployerData operation in GptApiApi.
 */
export interface GptApiApiGptApiSourceApnEmployerDataRequest {
    readonly apnEmployerDataScraperBody: ApnEmployerDataScraperBody
}

/**
 * Request parameters for gptApiSourceApnEmployerDataV2 operation in GptApiApi.
 */
export interface GptApiApiGptApiSourceApnEmployerDataV2Request {
    readonly apnEmployerDataScraperV2Body: ApnEmployerDataScraperV2Body
}

/**
 * Request parameters for gptApiSourceEmployerData operation in GptApiApi.
 */
export interface GptApiApiGptApiSourceEmployerDataRequest {
    readonly employerDataScraperBody: EmployerDataScraperBody
}

/**
 * Request parameters for gptApiSourceOptimEmployerData operation in GptApiApi.
 */
export interface GptApiApiGptApiSourceOptimEmployerDataRequest {
    readonly optimEmployerDataScraperBody: OptimEmployerDataScraperBody
}

/**
 * Request parameters for gptApiSourceQuestions operation in GptApiApi.
 */
export interface GptApiApiGptApiSourceQuestionsRequest {
    readonly sourceQuestionsBody: SourceQuestionsBody
}

/**
 * Request parameters for gptApiStartCourseGeneration operation in GptApiApi.
 */
export interface GptApiApiGptApiStartCourseGenerationRequest {
    readonly startCourseGenerationBody: StartCourseGenerationBody
}

/**
 * Request parameters for gptApiStartCourseGenerationPending operation in GptApiApi.
 */
export interface GptApiApiGptApiStartCourseGenerationPendingRequest {
    readonly startCourseGenerationBody: StartCourseGenerationBody
}

/**
 * Request parameters for gptApiStartQuestionDifficultyJob operation in GptApiApi.
 */
export interface GptApiApiGptApiStartQuestionDifficultyJobRequest {
    readonly startQuestionDifficultyBody: StartQuestionDifficultyBody
}

/**
 * Request parameters for gptApiStartRecruiterNormalisation operation in GptApiApi.
 */
export interface GptApiApiGptApiStartRecruiterNormalisationRequest {
    readonly recruiterNormalisationBody: RecruiterNormalisationBody
}

/**
 * Request parameters for gptApiStartSkillRelevanceRun operation in GptApiApi.
 */
export interface GptApiApiGptApiStartSkillRelevanceRunRequest {
    readonly skillRelevanceScope: SkillRelevanceScope
}

/**
 * Request parameters for gptApiStopEmployerSourcingRun operation in GptApiApi.
 */
export interface GptApiApiGptApiStopEmployerSourcingRunRequest {
    readonly runId: string
}

/**
 * Request parameters for gptApiStopSkillRelevanceRun operation in GptApiApi.
 */
export interface GptApiApiGptApiStopSkillRelevanceRunRequest {
    readonly runId: string
}

/**
 * Request parameters for gptApiStopValidationRun operation in GptApiApi.
 */
export interface GptApiApiGptApiStopValidationRunRequest {
    readonly runId: string
}

/**
 * Request parameters for gptApiUpdateSkillBuilderPromptTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiUpdateSkillBuilderPromptTemplateRequest {
    readonly templateId: string

    readonly skillBuilderPromptTemplateUpdateBody: SkillBuilderPromptTemplateUpdateBody
}

/**
 * Request parameters for gptApiUpdateSkillBuilderStrategyTemplate operation in GptApiApi.
 */
export interface GptApiApiGptApiUpdateSkillBuilderStrategyTemplateRequest {
    readonly templateId: string

    readonly skillBuilderStrategyTemplateUpdateBody: SkillBuilderStrategyTemplateUpdateBody
}

/**
 * Request parameters for gptApiUpsertSkillBuilderPromptMapping operation in GptApiApi.
 */
export interface GptApiApiGptApiUpsertSkillBuilderPromptMappingRequest {
    readonly skillBuilderPromptMappingUpsertBody: SkillBuilderPromptMappingUpsertBody
}

/**
 * Request parameters for gptApiUpsertSkillBuilderStrategyMapping operation in GptApiApi.
 */
export interface GptApiApiGptApiUpsertSkillBuilderStrategyMappingRequest {
    readonly skillBuilderStrategyMappingUpsertBody: SkillBuilderStrategyMappingUpsertBody
}

/**
 * Request parameters for gptApiValidateQuestions operation in GptApiApi.
 */
export interface GptApiApiGptApiValidateQuestionsRequest {
    readonly validateQuestionBody: ValidateQuestionBody
}

/**
 * GptApiApi - object-oriented interface
 */
export class GptApiApi extends BaseAPI {
    /**
     * 
     * @param {GptApiApiGptApiAiGenerateModuleHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAiGenerateModuleHierarchy(requestParameters: GptApiApiGptApiAiGenerateModuleHierarchyRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAiGenerateModuleHierarchy(requestParameters.generateModuleHierarchyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAnalyzeJobQualityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAnalyzeJobQuality(requestParameters: GptApiApiGptApiAnalyzeJobQualityRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAnalyzeJobQuality(requestParameters.orgJobID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiApplicantResumeAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiApplicantResumeAnalysis(requestParameters: GptApiApiGptApiApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAssignDomainsToQuestionsApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAssignDomainsToQuestionsApi(requestParameters: GptApiApiGptApiAssignDomainsToQuestionsApiRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAssignDomainsToQuestionsApi(requestParameters.iDListNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAssignDomainsToSkillsApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAssignDomainsToSkillsApi(requestParameters: GptApiApiGptApiAssignDomainsToSkillsApiRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAssignDomainsToSkillsApi(requestParameters.number, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAssignModulesToQuestionsApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAssignModulesToQuestionsApi(requestParameters: GptApiApiGptApiAssignModulesToQuestionsApiRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAssignModulesToQuestionsApi(requestParameters.assignModulesToQuestions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAssignModulesToSkillsApiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAssignModulesToSkillsApi(requestParameters: GptApiApiGptApiAssignModulesToSkillsApiRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAssignModulesToSkillsApi(requestParameters.iDListNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAutoRefineJobRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAutoRefineJobRole(requestParameters: GptApiApiGptApiAutoRefineJobRoleRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAutoRefineJobRole(requestParameters.refineJobRoleBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAutoRefineQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAutoRefineQuestions(requestParameters: GptApiApiGptApiAutoRefineQuestionsRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAutoRefineQuestions(requestParameters.refineQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAutoupdatePendingCollegesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAutoupdatePendingColleges(requestParameters: GptApiApiGptApiAutoupdatePendingCollegesRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAutoupdatePendingColleges(requestParameters.refineCollegeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiAutoupdatePendingCompaniesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiAutoupdatePendingCompanies(requestParameters: GptApiApiGptApiAutoupdatePendingCompaniesRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiAutoupdatePendingCompanies(requestParameters.refineCompanyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiBulkAnalysisUploadResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiBulkAnalysisUploadResume(requestParameters: GptApiApiGptApiBulkAnalysisUploadResumeRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiBulkAnalysisUploadResume(requestParameters.jobId, requestParameters.orgId, requestParameters.resumeFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiBulkAnalyzeResumeEntityJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiBulkAnalyzeResumeEntityJson(requestParameters: GptApiApiGptApiBulkAnalyzeResumeEntityJsonRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiBulkAnalyzeResumeEntityJson(requestParameters.idListLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCancelCourseGenerationJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCancelCourseGenerationJob(requestParameters: GptApiApiGptApiCancelCourseGenerationJobRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCancelCourseGenerationJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCourseRetireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCourseRetire(requestParameters: GptApiApiGptApiCourseRetireRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCourseRetire(requestParameters.retireExecuteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCourseRetirePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCourseRetirePreview(requestParameters: GptApiApiGptApiCourseRetirePreviewRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCourseRetirePreview(requestParameters.moduleId, requestParameters.beforeTs, requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCreateJobDescriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCreateJobDescription(requestParameters: GptApiApiGptApiCreateJobDescriptionRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCreateJobDescription(requestParameters.orgId, requestParameters.createJobDescriptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCreateSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCreateSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiCreateSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCreateSkillBuilderPromptTemplate(requestParameters.skillBuilderPromptTemplateCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiCreateSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiCreateSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiCreateSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiCreateSkillBuilderStrategyTemplate(requestParameters.skillBuilderStrategyTemplateCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDeleteGptResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDeleteGptResponse(requestParameters: GptApiApiGptApiDeleteGptResponseRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDeleteGptResponse(requestParameters.gptResponseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDeleteSkillBuilderPromptMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDeleteSkillBuilderPromptMapping(requestParameters: GptApiApiGptApiDeleteSkillBuilderPromptMappingRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDeleteSkillBuilderPromptMapping(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDeleteSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDeleteSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiDeleteSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDeleteSkillBuilderPromptTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDeleteSkillBuilderStrategyMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDeleteSkillBuilderStrategyMapping(requestParameters: GptApiApiGptApiDeleteSkillBuilderStrategyMappingRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDeleteSkillBuilderStrategyMapping(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDeleteSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDeleteSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiDeleteSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDeleteSkillBuilderStrategyTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiDownloadCsvApplicantResumeAnalysisPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiDownloadCsvApplicantResumeAnalysisPost(requestParameters: GptApiApiGptApiDownloadCsvApplicantResumeAnalysisPostRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiDownloadCsvApplicantResumeAnalysisPost(requestParameters.jobId, requestParameters.orgId, requestParameters.listJobResumeAnalysisBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * body with two arrays, not something that belongs in a query string.
     * @summary Counts and cost for a scope, spending nothing. POST because the scope is a
     * @param {GptApiApiGptApiEstimateSkillRelevanceScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiEstimateSkillRelevanceScope(requestParameters: GptApiApiGptApiEstimateSkillRelevanceScopeRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiEstimateSkillRelevanceScope(requestParameters.skillRelevanceScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGenerateSkillHierarchyDomainModuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGenerateSkillHierarchyDomainModule(requestParameters: GptApiApiGptApiGenerateSkillHierarchyDomainModuleRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGenerateSkillHierarchyDomainModule(requestParameters.refineByDomainModule, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetAllValidationRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetAllValidationRuns(requestParameters: GptApiApiGptApiGetAllValidationRunsRequest = {}, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetAllValidationRuns(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetApnaMissingJobs(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetApnaMissingJobs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetApplicantResumeAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetApplicantResumeAnalysis(requestParameters: GptApiApiGptApiGetApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetApplicantSkillsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetApplicantSkills(requestParameters: GptApiApiGptApiGetApplicantSkillsRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetApplicantSkills(requestParameters.jobId, requestParameters.orgId, requestParameters.searchQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetCourseGenerationJobStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetCourseGenerationJobStatus(requestParameters: GptApiApiGptApiGetCourseGenerationJobStatusRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetCourseGenerationJobStatus(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetCreateJobDescriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetCreateJobDescription(requestParameters: GptApiApiGptApiGetCreateJobDescriptionRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetCreateJobDescription(requestParameters.jdId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetEmployerSourcingRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetEmployerSourcingRuns(requestParameters: GptApiApiGptApiGetEmployerSourcingRunsRequest = {}, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetEmployerSourcingRuns(requestParameters.page, requestParameters.pageSize, requestParameters.source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetEmployerSourcingStats(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetEmployerSourcingStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetGptResponseHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetGptResponseHistory(requestParameters: GptApiApiGptApiGetGptResponseHistoryRequest = {}, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetGptResponseHistory(requestParameters.endDate, requestParameters.page, requestParameters.pageSize, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetNewGptResponseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetNewGptResponse(requestParameters: GptApiApiGptApiGetNewGptResponseRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetNewGptResponse(requestParameters.getNewGptResponseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetQuestionDifficultyJobStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetQuestionDifficultyJobStatus(requestParameters: GptApiApiGptApiGetQuestionDifficultyJobStatusRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetQuestionDifficultyJobStatus(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetSkillBuilderEffectiveStrategyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetSkillBuilderEffectiveStrategy(requestParameters: GptApiApiGptApiGetSkillBuilderEffectiveStrategyRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetSkillBuilderEffectiveStrategy(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetSkillBuilderEffectiveTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetSkillBuilderEffectiveTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderEffectiveTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetSkillBuilderEffectiveTemplate(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetSkillBuilderPromptTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiGetSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiGetSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiGetSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiGetSkillBuilderStrategyTemplate(requestParameters.templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiListApplicantResumeAnalysisPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiListApplicantResumeAnalysisPost(requestParameters: GptApiApiGptApiListApplicantResumeAnalysisPostRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiListApplicantResumeAnalysisPost(requestParameters.jobId, requestParameters.orgId, requestParameters.listJobResumeAnalysisBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiListCourseGenerationJobsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiListCourseGenerationJobs(requestParameters: GptApiApiGptApiListCourseGenerationJobsRequest = {}, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiListCourseGenerationJobs(requestParameters.limit, requestParameters.moduleId, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiListSkillBuilderPromptTemplates(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiListSkillBuilderPromptTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiListSkillBuilderStrategyTemplates(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiListSkillBuilderStrategyTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiListSkillRelevanceRuns(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiListSkillRelevanceRuns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiNormaliseOptimEmployerData(options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiNormaliseOptimEmployerData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiProcessParsedQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiProcessParsedQuestions(requestParameters: GptApiApiGptApiProcessParsedQuestionsRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiProcessParsedQuestions(requestParameters.processParsedQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiProcessResumeEntitiesStudyStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiProcessResumeEntitiesStudyStatus(requestParameters: GptApiApiGptApiProcessResumeEntitiesStudyStatusRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiProcessResumeEntitiesStudyStatus(requestParameters.number, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiResumeEmployerSourcingRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiResumeEmployerSourcingRun(requestParameters: GptApiApiGptApiResumeEmployerSourcingRunRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiResumeEmployerSourcingRun(requestParameters.runId, requestParameters.resumeEmployerSourcingRunBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiRetryApplicantResumeAnalysisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiRetryApplicantResumeAnalysis(requestParameters: GptApiApiGptApiRetryApplicantResumeAnalysisRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiRetryApplicantResumeAnalysis(requestParameters.analysisId, requestParameters.jobId, requestParameters.orgId, requestParameters.force, requestParameters.jobId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * skill list is an array, not something that belongs in a query string.
     * @summary How many of each skill\'s questions already carry a weight. POST because the
     * @param {GptApiApiGptApiSkillRelevanceCoverageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSkillRelevanceCoverage(requestParameters: GptApiApiGptApiSkillRelevanceCoverageRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSkillRelevanceCoverage(requestParameters.skillCoverageBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiSourceApnEmployerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSourceApnEmployerData(requestParameters: GptApiApiGptApiSourceApnEmployerDataRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSourceApnEmployerData(requestParameters.apnEmployerDataScraperBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiSourceApnEmployerDataV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSourceApnEmployerDataV2(requestParameters: GptApiApiGptApiSourceApnEmployerDataV2Request, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSourceApnEmployerDataV2(requestParameters.apnEmployerDataScraperV2Body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiSourceEmployerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSourceEmployerData(requestParameters: GptApiApiGptApiSourceEmployerDataRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSourceEmployerData(requestParameters.employerDataScraperBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiSourceOptimEmployerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSourceOptimEmployerData(requestParameters: GptApiApiGptApiSourceOptimEmployerDataRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSourceOptimEmployerData(requestParameters.optimEmployerDataScraperBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiSourceQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiSourceQuestions(requestParameters: GptApiApiGptApiSourceQuestionsRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiSourceQuestions(requestParameters.sourceQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStartCourseGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStartCourseGeneration(requestParameters: GptApiApiGptApiStartCourseGenerationRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStartCourseGeneration(requestParameters.startCourseGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStartCourseGenerationPendingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStartCourseGenerationPending(requestParameters: GptApiApiGptApiStartCourseGenerationPendingRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStartCourseGenerationPending(requestParameters.startCourseGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStartQuestionDifficultyJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStartQuestionDifficultyJob(requestParameters: GptApiApiGptApiStartQuestionDifficultyJobRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStartQuestionDifficultyJob(requestParameters.startQuestionDifficultyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStartRecruiterNormalisationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStartRecruiterNormalisation(requestParameters: GptApiApiGptApiStartRecruiterNormalisationRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStartRecruiterNormalisation(requestParameters.recruiterNormalisationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStartSkillRelevanceRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStartSkillRelevanceRun(requestParameters: GptApiApiGptApiStartSkillRelevanceRunRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStartSkillRelevanceRun(requestParameters.skillRelevanceScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStopEmployerSourcingRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStopEmployerSourcingRun(requestParameters: GptApiApiGptApiStopEmployerSourcingRunRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStopEmployerSourcingRun(requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStopSkillRelevanceRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStopSkillRelevanceRun(requestParameters: GptApiApiGptApiStopSkillRelevanceRunRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStopSkillRelevanceRun(requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiStopValidationRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiStopValidationRun(requestParameters: GptApiApiGptApiStopValidationRunRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiStopValidationRun(requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiUpdateSkillBuilderPromptTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiUpdateSkillBuilderPromptTemplate(requestParameters: GptApiApiGptApiUpdateSkillBuilderPromptTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiUpdateSkillBuilderPromptTemplate(requestParameters.templateId, requestParameters.skillBuilderPromptTemplateUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiUpdateSkillBuilderStrategyTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiUpdateSkillBuilderStrategyTemplate(requestParameters: GptApiApiGptApiUpdateSkillBuilderStrategyTemplateRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiUpdateSkillBuilderStrategyTemplate(requestParameters.templateId, requestParameters.skillBuilderStrategyTemplateUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiUpsertSkillBuilderPromptMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiUpsertSkillBuilderPromptMapping(requestParameters: GptApiApiGptApiUpsertSkillBuilderPromptMappingRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiUpsertSkillBuilderPromptMapping(requestParameters.skillBuilderPromptMappingUpsertBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiUpsertSkillBuilderStrategyMappingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiUpsertSkillBuilderStrategyMapping(requestParameters: GptApiApiGptApiUpsertSkillBuilderStrategyMappingRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiUpsertSkillBuilderStrategyMapping(requestParameters.skillBuilderStrategyMappingUpsertBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GptApiApiGptApiValidateQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gptApiValidateQuestions(requestParameters: GptApiApiGptApiValidateQuestionsRequest, options?: RawAxiosRequestConfig) {
        return GptApiApiFp(this.configuration).gptApiValidateQuestions(requestParameters.validateQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const GptApiGetEmployerSourcingRunsSourceEnum = {
    Unstop: 'unstop',
    ApnaJobs: 'apna_jobs',
    ApnaContacts: 'apna_contacts',
    Normalise: 'normalise',
} as const;
export type GptApiGetEmployerSourcingRunsSourceEnum = typeof GptApiGetEmployerSourcingRunsSourceEnum[keyof typeof GptApiGetEmployerSourcingRunsSourceEnum];
